/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import {
  Divider,
  Tooltip,
} from '@material-ui/core';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  CommonPagination,
  ScreenContainer,
  CommonButton,
} from '../../CommonComponents';
import {
  getAllSites,
  getSitesDataByEstimateId,
  updatePrimaryQuery,
} from '../../redux/actions/sites';
import SitesFilter from '../../CommonComponents/SitesFilter/SitesFilter';
import PrimaryFilters from '../../CommonComponents/PrimaryFilters';
import FallbackCard from '../../CommonComponents/FallbackCard';
import {
  exportSitesForDefaultPicture,
  importSitesDefaultPicture,
} from '../../redux/actions/common';
import DefaultImagesTable from './DefaultImagesTable';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const DefaultImages = ({
  getAllSitesAction,
  totalSitePages,
  updateQuery,
  primaryQuery,
  searchQuery,
  fetchSites,
  exportDefaultSites,
  importSitesDefault,
}) => {
  const query = useQuery();
  const history = useHistory()
  const page = parseInt(query.get('page') || '1', 10);
  const [showSites, enableSites] = useState(false);
  const [estimateId, setEstimateId] = useState(null)
  const [selected, setSelected] = useState([]);
  const [checkBoxState, setCheckbox] = React.useState(true);

  useEffect(() => {
    const pno = query.get('page')
    if (showSites && pno) { getAllSitesAction(page, searchQuery, primaryQuery); }
  }, [query, getAllSitesAction, searchQuery, primaryQuery, showSites, page]);

  const fetchAllSite = (val) => {
    setSelected([]);
    setCheckbox(true);
    setEstimateId(val)
    if (query.has('estimateId')) {
      query.set('estimateId', val)
    } else {
      query.append('estimateId', val)
    }
    query.delete('page')
    history.push('/proposed-photos')
    updateQuery(query.toString())
    fetchSites(val);
    enableSites(true);
  }

  const exportDefaultPicture = async () => {
    await exportDefaultSites(estimateId, selected);
    setSelected([]);
  }

  const handleChangeDefualtPicture = (files) => {
    importSitesDefault(files[0], estimateId, page, searchQuery, primaryQuery)
  }
  const userType = JSON.parse(localStorage.getItem('user'));
  return (
    <ScreenContainer title="Proposed Photo Sites">
      <PrimaryFilters
        visibleProduct
        visibleEstimate
        fetchFunction={fetchAllSite}
        location="allsites"
        showFetchButton

      />
      <br />
      {estimateId && userType && (userType.userType === 'admin' || userType.userType === 'manager')
        ? (
          <div className="row">
            <div className="col-12">
              <input
                accept=".zip,application/zip"
                style={{ display: 'none' }}
                id="import-sites-default-picture"
                onChange={(e) => handleChangeDefualtPicture(e.target.files)}
                type="file"
              />
              <Tooltip disableFocusListener title="Please make sure you have keep correct image names." placement="right" arrow>
                <label htmlFor="import-sites-default-picture">
                  <CommonButton
                    variant="raised"
                    component="span"
                  >
                    <b className="text-primary">Import Proposed Photo</b>
                  </CommonButton>
                </label>
              </Tooltip>
            </div>
          </div>
        )
        : null}
      {showSites
        ? (
          <>
            <SitesFilter currentLocation="proposed-photos" setSelected={setSelected} />
            <div className="row">
              <Divider />
              <div className="col-12">
                <br />
                <DefaultImagesTable
                  setSelected={setSelected}
                  selected={selected}
                  setCheckbox={setCheckbox}
                  checkBoxState={checkBoxState}
                  exportDefaultPicture={exportDefaultPicture}
                />
                {totalSitePages > 1 ? (
                  <CommonPagination
                    baseUrl="proposed-photos"
                    totalPages={totalSitePages}
                  />
                ) : null}
                <br />
                <br />
              </div>
            </div>
          </>
        )
        : <FallbackCard text="Fetch the sites to start" />}
    </ScreenContainer>
  );
};

const mapState = (state) => ({
  totalSitePages: state.sites.totalSitePages,
  searchQuery: state.sites.searchQuery,
  primaryQuery: state.sites.primaryQuery,
});

const mapActions = {
  getAllSitesAction: getAllSites,
  fetchSites: getSitesDataByEstimateId,
  updateQuery: updatePrimaryQuery,
  exportDefaultSites: exportSitesForDefaultPicture,
  importSitesDefault: importSitesDefaultPicture,
};

export default connect(mapState, mapActions)(DefaultImages);
